module.exports = __webpack_public_path__ + "bottom_img.png?3fcc80f21782d1f064ffdfdade6645e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom_img.png
// module id = 90
// module chunks = 0